export const HOME = '/';
export const DYNACOOL = '/dynacool';
export const SQUID = '/squid';
export const DILFRIDGE = '/dilutionrefrigerator';